import { FormLabelProps } from "@chakra-ui/react";

export const FORM_LABEL_STYLES = {
  baseStyle: {
    textTransform: "uppercase",
    color: "brand.analytic",
    fontSize: "sm",
    letterSpacing: "1px",
    fontWeight: "semibold",
    display: "flex",
    m: 0,
  } as FormLabelProps,
};
